import { api } from "@/redux/api";

import { RequestPaginationParams } from "@/types/request-params";

import {
	ApiKey,
	ApiKeyDeleteResponse,
	ApiKeyDeleteResponseSchema,
	ApiKeyResponse,
	ApiKeyResponseSchema,
	CreateApiKey,
} from "../../pages/Company/pages/ApiKeyOverview/schema/apiKey";

export const apiKeyApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getApiKeys: builder.query<ApiKeyResponse, RequestPaginationParams>({
			query: (params) => ({
				url: `/apiKey`,
				params: {
					...(params && { ...params }),
				},
				method: "GET",
				responseSchema: ApiKeyResponseSchema,
			}),
			providesTags: ["ApiKeys"],
		}),
		createApiKey: builder.mutation<ApiKey, CreateApiKey>({
			query: (data) => ({
				url: `/apiKey`,
				method: "POST",
				body: data,
				responseSchema: ApiKeyResponseSchema,
			}),
			invalidatesTags: ["ApiKeys"],
		}),
		deleteApiKey: builder.mutation<ApiKeyDeleteResponse, number>({
			query: (id) => ({
				url: `apiKey/${id}`,
				method: "DELETE",
				responseSchema: ApiKeyDeleteResponseSchema,
			}),
			invalidatesTags: ["ApiKeys"],
		}),
	}),
});

export const { useCreateApiKeyMutation, useDeleteApiKeyMutation, useGetApiKeysQuery } = apiKeyApi;
export const apiKeyApiReducer = apiKeyApi.reducer;
export const apiKeyApiMiddleware = apiKeyApi.middleware;
